export const COMPANY_APPOVED_STATUS = 'APPROVED';
export const COMPANY_REJECTED_STATUS = 'REJECTED';
